export default "__VITE_PUBLIC_ASSET__c218c9f8__"